import { Search } from "lucide-react";
import { Input } from "./Input";
import { useTranslation } from "react-i18next";

const SearchInput = ({
  value = null,
  onChangeHandler,
  placeholder = "defaults.searchInputPlaceholder",
}) => {
  const { t } = useTranslation();

  return (
    <div className="relative ml-auto flex-1 md:grow-0">
      <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
      <Input
        type="search"
        placeholder={t(placeholder)}
        className="w-full rounded-lg bg-background pl-8 md:w-[200px] lg:w-[320px]"
        onChange={onChangeHandler}
        value={value}
      />
    </div>
  );
};

export default SearchInput;
